/* eslint-disable react/no-danger */

import React, { Component } from 'react';
import Image from './../../../../../components/ZUILib/Image';
import commonUtil from '../../../../../utils/commonUtil';

class ListItem extends Component {

  handleClick = (itemData, categoryName) => {
    const dataLayer = {
      event: 'select_item',
      seccion: 'Mesa de regalos',
      phase: 'Mesa de regalos',
      phase_detail: 'Lista',
      item_list_name: 'Lista de festejado',
      list: `${this.props.eventId} | Lista mesa`,
      specific_generator: 'Y',
      generator_type: 'Lista Mesa',
      generator_value: `${this.props.eventId}`,
      items: [{
        item_id: itemData.skuId,
        item_variant: itemData.skuId,
        item_name: itemData.name,
        item_category: categoryName,
        price: itemData.salePrice,
        original_price: itemData.listPrice,
        quantity: itemData.quantity,
        gift_list_number: `${this.props.eventId}`,
      }],
    };
    window.dataLayer.push(dataLayer);
    this.props.showContent(itemData, categoryName);
  };

  render() {
    this.ItemInfo = this.props.categoryInfo;
    const labels = this.props.labels;
    const productImageSrc = {
      media: '(max-width: 465px)',
      srcSet: this.ItemInfo.imageURL,
    };
    if (this.ItemInfo.categoryName === commonUtil.getLabel(labels.GuestviewPage, 'guestview.gift.certificate.name.label')) {
      this.defaultImage = commonUtil.getAssetURL() + '/images/certificado.jpg';
    } else {
      this.defaultImage = commonUtil.getAssetURL() + "/images/guest/no-image.png";
    }
    const productImageAttribute = {
      id: 'img1',
      alt: 'Liverpool',
      src: this.ItemInfo.imageURL,
      altImg: this.ItemInfo?.altImageUrl || this.defaultImage,
      className: 'imgProduct',
      pictureHtmlStyle:{
        flexPicture:'flex',
        alignPicture:'center'
      }
    };
    return (
      <div className="productContent">
        <div className="productImg product hover-icon">
          <Image
            imageAttr={productImageAttribute}
            _imgsrc={productImageSrc || commonUtil.getAssetURL() + "/images/guest/no-image.png"}
            key={this.ItemInfo.giftItemId}
            onClick={() => this.handleClick(this.ItemInfo, this.ItemInfo.categoryName)}
          />
        </div>
        <div className="productInfo-grid">
        <p
          className="titleProduct hover-icon"
          onClick={() => this.handleClick(this.ItemInfo, this.ItemInfo.categoryName)}
        >
          {this.ItemInfo.name}
        </p>
        <span className='sku_id_listHead'>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.sku.label')} <span className='sku_id_listitem'>{this.ItemInfo && this.ItemInfo.skuId || ''}</span></span>
        <div className="priceProductContainer">
        {Number(this.ItemInfo.salePrice) < Number(this.ItemInfo.listPrice) && this.ItemInfo.categoryName !== commonUtil.getLabel(labels.GuestviewPage, 'guestview.gift.certificate.name.label') ?
          <React.Fragment>
            <p className="salePrice" dangerouslySetInnerHTML={{ __html: commonUtil.getHtmlCurrency(this.ItemInfo.listPrice) }} />
            <p className="priceProduct" dangerouslySetInnerHTML={{ __html: commonUtil.getHtmlCurrency(this.ItemInfo.salePrice) }} />
          </React.Fragment>
          :
          <p className="priceProduct" dangerouslySetInnerHTML={{ __html: commonUtil.getHtmlCurrency(this.ItemInfo.listPrice) }} />}
        </div>
        <p className="quantityProduct">{commonUtil.getLabel(labels.GuestviewPage, 'guestview.quantity.label')} <span>{this.ItemInfo.quantity}</span></p>
        </div>
        {this.ItemInfo.isFavourite ? <img src={commonUtil.getAssetURL() + '/images/starrr.svg'} className="star_rating_listitem" /> : ''}
      </div>
    );
  }
}
export default ListItem;
